import Loading from '@/common/atoms/Loading'
import { Button, Heading, useToast, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { trpc } from 'src/trpc'

export default function AdminMaintenancePage() {
  const { t } = useTranslation()
  const toast = useToast()
  const [loading, setLoading] = useState(false)

  // Says how it went, and never stays on « en cours » (#154)
  const handleSearchReindex = async () => {
    setLoading(true)
    try {
      const report = await trpc.search.reindexAll.mutate()
      const incomplete = report.skipped > 0 || report.failedTables.length > 0
      toast({
        title: t('SuperAdmin.maintenance.searchReindexDone', report),
        description: incomplete
          ? t('SuperAdmin.maintenance.searchReindexIncomplete', {
              skipped: report.skipped,
              tables: report.failedTables.join(', ') || '—',
            })
          : undefined,
        status: incomplete ? 'warning' : 'success',
        duration: incomplete ? null : 5000,
        isClosable: true,
      })
    } catch (error: any) {
      toast({
        title: t('common.error'),
        description: error?.message,
        status: 'error',
        duration: null,
        isClosable: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleRecomputeCircleParticipantCache = async () => {
    setLoading(true)
    await trpc.participants.recomputeCache.mutate()
    setLoading(false)
  }

  return (
    <>
      <Heading size="md" mb={6}>
        {t('SuperAdmin.maintenance.heading')}
      </Heading>

      {loading && <Loading active center />}

      <VStack align="start">
        <Button
          size="sm"
          colorScheme="orange"
          isDisabled={loading}
          onClick={handleSearchReindex}
        >
          {t('SuperAdmin.maintenance.searchReindex')}
        </Button>

        <Button
          size="sm"
          colorScheme="orange"
          isDisabled={loading}
          onClick={handleRecomputeCircleParticipantCache}
        >
          {t('SuperAdmin.maintenance.recomputeCache')}
        </Button>
      </VStack>
    </>
  )
}
